export default __webpack_public_path__ + "static/media/1.35d1d9d0.mp4";